import { render, staticRenderFns } from "./ArtistSelectDropdown.vue?vue&type=template&id=a3a319aa&scoped=true&"
import script from "./ArtistSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./ArtistSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ArtistSelectDropdown.vue?vue&type=style&index=0&id=a3a319aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a319aa",
  null
  
)

export default component.exports